import styled, { createGlobalStyle } from 'styled-components';

export const ImageModalFullscreenStyles = createGlobalStyle`
  .image-modal-wrapper.fullscreen-mode {
    background: #000;
    
    .carousel-container {
      background: #000;
    }
    
    .carousel-slide {
      background: #000;
    }
    
    .carousel-arrow {
      background: rgba(255, 255, 255, 0.1);
      border: 1px solid rgba(255, 255, 255, 0.3);
      
      &:hover {
        background: rgba(255, 255, 255, 0.2);
      }
    }
    
    .carousel-bullet {
      background: rgba(255, 255, 255, 0.5);
      
      &.active {
        background: rgba(255, 255, 255, 1);
      }
    }
  }
  
  .image-modal-wrapper.fullscreen-mode img {
    filter: brightness(1.1);
  }
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
`;

export const MediaContainer = styled.div<{ $isFullScreen: boolean }>`
  width: 100%;
  height: ${props => props.$isFullScreen ? '100vh' : 'auto'};
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`;

export const VideoElement = styled.video`
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
`;

export const ImageElement = styled.img`
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  display: block;
  margin: 0 auto;
`;

export const ButtonsContainer = styled.div`
  position: absolute;
  bottom: 20px;
  right: 20px;
  display: flex;
  gap: 12px;
  z-index: 10;
`;

export const ActionButton = styled.button`
  background: rgba(255, 255, 255, 0.9);
  border: none;
  border-radius: 50%;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);

  &:hover {
    background: rgba(255, 255, 255, 1);
    transform: scale(1.1);
  }
`;
